import Changeset from 'ember-changeset';
import globalFlowValidations from 'garaje/validations/global-flow';
import lookupValidator from 'ember-changeset-validations';

export default function (globalFlow) {
  const validator = lookupValidator(globalFlowValidations);

  return new Changeset(globalFlow, validator, globalFlowValidations);
}
